import React, {useEffect, useState} from 'react';
import {useOnboardingContext} from './Onboarding';
import {Flex, Button, Box, Divider} from '@chakra-ui/react';
import {useUpdateWebsite} from '../../hooks/api/customer';
import {ScrollableFlex, WrapperFlex} from '../utils/scrolling';
import {useCustomer} from '../../hooks/api/metadata';
import {useAccountWithLogo} from '../../hooks/api/accountWithLogo';
import {
  CreatableDomainTypeahead,
  DomainSelection,
} from '../CreatableDomainTypeahead';

export const SetWebsite = () => {
  const customer = useCustomer();
  const {onPageNavigate, isFirstStep} = useOnboardingContext();
  const updateWebsite = useUpdateWebsite();
  const [selectedDomain, setSelectedDomain] = useState<
    DomainSelection | undefined
  >(undefined);
  const account = useAccountWithLogo(
    customer.website?.accountId ?? 'skipToken'
  );

  useEffect(() => {
    if (!customer.website) {
      return;
    }

    if (account.data) {
      setSelectedDomain({
        domain: account.data.domain,
        accountId: account.data._id,
        name: account.data.name,
      });
    } else if (!customer.website.accountId && customer.website.domain) {
      setSelectedDomain({
        domain: customer.website.domain,
      });
    }
  }, [account.data, customer.website, setSelectedDomain]);

  const onNext = async () => {
    if (!selectedDomain) {
      return;
    }

    updateWebsite.mutate(
      {
        domain: selectedDomain.domain,
        accountId: selectedDomain.accountId,
      },
      {
        onSuccess: () => {
          onPageNavigate('next');
        },
      }
    );
  };

  return (
    <WrapperFlex>
      <ScrollableFlex gap={12}>
        <Flex direction="column" gap={5}>
          <Box fontSize="2xl">
            Now, add your website and we&apos;ll pinpoint your ICP
          </Box>
          <Box color="kgray.300">
            A little magic to help you start exploring Keyplay faster.
          </Box>
        </Flex>
        <Box w="100%">
          <CreatableDomainTypeahead
            selectedDomain={selectedDomain}
            onDomainSelect={setSelectedDomain}
            isDisabled={account.isFetching}
          />
        </Box>
      </ScrollableFlex>

      <Divider />

      <Flex justifyContent="space-between" w="100%" px={10} py={4}>
        {!isFirstStep && (
          <Button
            colorScheme="kbuttonblue"
            onClick={() => onPageNavigate('prev')}
            variant="outline"
            w="110px"
          >
            Back
          </Button>
        )}
        <Box flexGrow={1} />
        <Button
          colorScheme="kbuttonblue"
          isDisabled={!selectedDomain || updateWebsite.isPending}
          isLoading={updateWebsite.isPending}
          onClick={onNext}
          variant="solid"
        >
          Continue
        </Button>
      </Flex>
    </WrapperFlex>
  );
};
